export const TASKS_MAP_DARK_STYLES: google.maps.MapTypeStyle[] = [
  { elementType: 'geometry', stylers: [{ color: '#1d1d1d' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#8a8a8a' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#1d1d1d' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#2c2c2c' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#212121' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#3c3c3c' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0e1626' }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
]

export const TASKS_MAP_DEFAULT_CENTER = { lat: 43.6895, lng: -79.3924 } as const

export const TASKS_MAP_DEFAULT_OPTIONS: google.maps.MapOptions = {
  center: TASKS_MAP_DEFAULT_CENTER,
  zoom: 12,
  styles: TASKS_MAP_DARK_STYLES,
  backgroundColor: '#1d1d1d',
  zoomControl: true,
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: false,
  scaleControl: false,
  rotateControl: false,
  clickableIcons: false,
  disableDoubleClickZoom: true,
}
